module.exports = __webpack_public_path__ + "static/media/facebook-final.8e6b893f.svg";